const style = {
  filterPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
    '@media (max-width: 850px)': {
      gap: '24px'
    }
  },
  filterPanelContainer: {
    maxWidth: '70%',
    width: '100%',
    padding: 0
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    '@media (max-width: 850px)': {
      flexDirection: 'column',
      alignItems: 'center',
      gap: 0
    }
  },
  label: {
    minWidth: '100px'
  },
  input: {
    flex: 1,
    width: '100%'
  },
  datePickerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    width: '100%',
    '@media (max-width: 850px)': {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: '8px'
    }
  }
}

export default style
